<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_VIEW_MAP')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Bản đồ nhiệt cho Merchant</h1>
      <div class="mt-3 line">
        <div class="row">
          <div class="col-md-8">
            <div class="m-b-10">
              <form class="box-search mx-2" @submit.prevent="clickSearch">
                <div class="clearfix row">
                  <div class="form-group">
                    <Select2
                      placeholder="Vùng"
                      v-model="region"
                      :options="optionRegion"
                      @change="getProvince($event)"
                    />
                  </div>
                  <div class="form-group">
                    <Select2
                      placeholder="Tỉnh/Thành phố"
                      v-model="province"
                      :options="optionProvince"
                      :disabled="!region"
                      @change="getDistrict($event)"
                    />
                  </div>
                  <div class="form-group">
                    <Select2
                      placeholder="Quận/Huyện"
                      v-model="district"
                      :options="optionDistrict"
                      :disabled="!province"
                      @change="changeDistrict($event)"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      v-model="strCityCodeList"
                      placeholder="Các vùng chỉ định"
                      class="border-radis-3"
                    />
                  </div>
                </div>
                <div class="clearfix mt-1 row w-100">
                  <div class="col-md-4 pl-0 pr-2">
                    <label>Ngành hàng(chọn nhiều)</label>
                    <select2-multiple-control
                      v-model="mcc"
                      :options="dataConfigMcc"
                      placeholder="Ngành hàng"
                    />
                  </div>
                  <div class="col-md-4 pl-0 pr-2">
                    <label>Dịch vụ(chọn nhiều)</label>
                    <select2-multiple-control
                      v-model="searchServiceType"
                      :options="dataConfigService"
                      placeholder="Dịch vụ"
                    />
                  </div>
                  <div class="col-md-2 pl-0 pr-2">
                    <label>Cấp khu vực</label>
                    <div>
                      <input
                        type="number"
                        v-model="locationLevel"
                        min="0"
                        placeholder="Cấp khu vực"
                        class="border-radis-3"
                      />
                    </div>
                  </div>
                  <div class="col-md-2 px-0 d-flex gap-2 align-items-center mt-4">
                    <b-button :pressed="false" variant="primary" @click="clickSearch" class="mr-2">
                      Lấy số liệu
                    </b-button>
                    <b-button :pressed="false" variant="danger" @click="removeStrCityCodeList">
                      Reset
                    </b-button>
                  </div>
                </div>
              </form>
              <div class="mt-3 mb-3">
                <p class="px-0">Chú thích bảng màu:</p>
                <div class="clearfix mt-2 row mx-0">
                  <div class="d-flex" v-for="(item, index) in arrNoDegrees" :key="index">
                    <div
                      :style="`background-color: ${item.color};
                  width: 100px; display: flex; justify-content: center; align-items: center; border: 1px dotted black; padding: 3px 0px 3px 0px`"
                    >
                      <span>{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <GmapMap
              @click="clickMap"
              :clickable="true"
              ref="map"
              :center="googleMap.center"
              :zoom="5"
              style="width: 100%; height: 580px"
              :options="googleMap.options"
              @dragend="dragMap"
              @center_changed="changeMapCenter($event)"
            >
              <GmapPolygon
                :key="index"
                v-for="(m, index) in locations"
                :paths="m.polygon"
                :options="m.options"
                @click="showLocationDetails($event, m)"
              />
              <gmap-info-window
                :options="infoWindow.options"
                :position="infoWindow.position"
                :opened="infoWindow.isOpened"
                @closeclick="infoWindow.isOpened = false"
              />
            </GmapMap>
          </div>
          <div class="col-md-4 border-left">
            <div>
              <!-- Loading State -->
              <div v-if="loadingScreen" class="loading-state">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Đang tải...</span>
                </div>
                <p class="mt-3">Đang tải dữ liệu...</p>
              </div>

              <!-- Table Content -->
              <div v-else class="table-content">
                <div class="mb-3">
                  <div class="stats-row">
                    <div class="stat-item">
                      <span class="stat-label">Tổng khu vực:</span>
                      <span class="badge badge-primary">{{ dataShow.length }}</span>
                    </div>
                  </div>
                  <div class="mt-2 color-level-detail">
                    <p v-for="(count, level) in colorLevelStats" :key="level" class="level-badge">
                      Cấp {{ level }}: <b>{{ count }}</b>
                    </p>
                  </div>
                </div>
                <div>
                  <b-table
                    id="my-table"
                    striped
                    hover
                    :current-page="pageIndex"
                    :per-page="perPage"
                    :items="dataShow"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    class="merchant-table"
                  />
                </div>
                <b-pagination
                  v-model="pageIndex"
                  :total-rows="dataShow.length"
                  :per-page="perPage"
                  aria-controls="my-table"
                  class="mt-3"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable comma-dangle */
  import { CommonService } from '../../services/common.service'
  import { mapGetters } from 'vuex'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import Config from '../../thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { MerchantService } from '@/services/merchant.service'
  import { googleMapOptions } from '@/config/manhthdConfigs'
  import { LocationService } from '@/services/location.service'

  export default {
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        noPersonPerDegree: 1000,
        noDegrees: 11,
        loadingScreen: false,
        dataConfigMcc: [],
        dataConfigService: [],
        mcc: [],
        searchServiceType: [],
        resRegion: [],
        optionRegion: [],
        region: '',
        optionProvince: [],
        province: '',
        resProvince: [],
        optionDistrict: [],
        resDistrict: [],
        district: '',
        locationLevel: 2,
        strCityCodeList: '',
        dataShow: [],
        fields: [
          { key: 'locationName', label: 'Tên địa điểm', sortable: true },
          { key: 'noMerchants', label: 'Số Merchant', sortable: true },
          {
            key: 'mapIndex',
            label: 'Cấp màu',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        perPage: 15,
        pageIndex: 1,
        sortBy: 'locationName',
        sortDesc: false,
        params: {},
        infoWindow: {
          position: undefined,
          isOpened: false,
          options: {
            pixelOffset: {
              width: 0,
              height: -35,
            },
            content: '',
          },
        },
        googleMap: {
          center: {
            lat: 15.938174,
            lng: 107.754545,
          },
          options: {
            gestureHandling: 'greedy',
            styles: googleMapOptions.nightThemeStyles,
          },
        },
        locations: [],
        arrNoDegrees: [],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      colorLevelStats() {
        const stats = {}
        this.dataShow.forEach(item => {
          const level = item.mapIndex
          stats[level] = (stats[level] || 0) + 1
        })
        return stats
      },
      totalColorLevels() {
        return Object.keys(this.colorLevelStats).length
      },
    },
    async created() {
      await this.configSystem()
      await this.getRegions()
      await this.clickSearch()
    },
    methods: {
      getArrNoDegrees() {
        if (Number(this.locationLevel) === 3) {
          this.arrNoDegrees = [
            { value: '0 - 5', color: 'HSL(50, 90%, 100%)', min: -1000000000, max: 5 },
            { value: '6 - 44', color: 'hsla(48, 90%, 50%, 1)', min: 6, max: 44 },
            { value: '45 - 83', color: 'hsla(46, 90%, 50%, 1)', min: 45, max: 83 },
            { value: '84 - 122', color: 'hsla(43, 90%, 50%, 1)', min: 84, max: 122 },
            { value: '123 - 160', color: 'hsla(42, 90%, 50%, 1)', min: 123, max: 160 },
            { value: '161 - 370', color: 'hsla(41.67, 90%, 50%, 1)', min: 161, max: 370 },
            { value: '371 - 580', color: 'hsla(33.34, 90%, 50%, 1)', min: 371, max: 580 },
            { value: '581 - 790', color: 'hsla(25.01, 90%, 50%, 1)', min: 581, max: 790 },
            { value: '791 - 1000', color: 'hsla(16.68, 90%, 50%, 1)', min: 791, max: 1000 },
            { value: '1001 - 5000', color: 'hsla(8.34, 90%, 50%, 1)', min: 1001, max: 5000 },
            { value: '5001 - 9000', color: 'hsla(0, 90%, 50%, 1)', min: 5001, max: 1000000000 },
          ]
          return
        }
        this.arrNoDegrees = [
          { value: '0 - 10', color: 'HSL(50, 90%, 100%)', min: -1000000000, max: 10 },
          { value: '11 - 999', color: 'hsla(48, 90%, 50%, 1)', min: 11, max: 999 },
          { value: '1000 - 1999', color: 'hsla(46, 90%, 50%, 1)', min: 1000, max: 1999 },
          { value: '2000 - 2999', color: 'hsla(43, 90%, 50%, 1)', min: 2000, max: 2999 },
          { value: '3000 - 3999', color: 'hsla(42, 90%, 50%, 1)', min: 3000, max: 3999 },
          { value: '4000 - 4999', color: 'hsla(41.67, 90%, 50%, 1)', min: 4000, max: 4999 },
          { value: '5000 - 5999', color: 'hsla(33.34, 90%, 50%, 1)', min: 5000, max: 5999 },
          { value: '6000 - 6999', color: 'hsla(25.01, 90%, 50%, 1)', min: 6000, max: 6999 },
          { value: '7000 - 7999', color: 'hsla(16.68, 90%, 50%, 1)', min: 7000, max: 7999 },
          { value: '8000 - 8999', color: 'hsla(8.34, 90%, 50%, 1)', min: 8000, max: 8999 },
          { value: '>= 9000', color: 'hsla(0, 90%, 50%, 1)', min: 9000, max: 1000000000 },
        ]
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              data.data.services.map(e => this.dataConfigService.push({ id: e.code, text: e.name }))
              this.getListService()
              data.data.businessFields.map(e =>
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              )
            }
          })
          .catch(error => {
            this.error = error.message
          })
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              data[0].detail.map(e => {
                const body = {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
                this.dataConfigService.push(body)
              })
            }
          }
        } catch (error) {}
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.success) {
          this.optionRegion = []
          this.optionRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.optionRegion.push({ id: e.id, text: e.name })
          })
          this.resRegion = data.data
        }
      },
      async getProvince(e) {
        try {
          // Reset province and district when region changes
          this.province = ''
          this.district = ''
          this.optionDistrict = []
          this.resDistrict = []

          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            if (this.region === '0') {
              this.optionProvince = []
              this.resProvince = []
            } else {
              this.optionProvince = data.data.map(e => {
                return { id: e.id, text: e.name }
              })
              this.resProvince = data.data
            }
          }
          this.arrCityCodeList(e)
        } catch (error) {}
      },
      async getDistrict(e) {
        // Reset district when province changes
        this.district = ''
        this.strCityCodeList = ''
        this.resDistrict = []
        this.optionDistrict = []

        let cityCode = ''
        if (e !== '') {
          this.resProvince.forEach(item => {
            if (item.id === e) {
              cityCode = item.code
              this.strCityCodeList = cityCode
            }
          })
        }
        const data = await StaffService.getDistictByCode({ cityCode: cityCode })
        if (data.success) {
          data.data.map(e => {
            this.optionDistrict.push({ id: e.id || e.code, text: e.name })
          })
          this.resDistrict = data.data
        }
      },
      async changeDistrict(e) {
        this.resDistrict.forEach(item => {
          if (item.id === e) {
            this.strCityCodeList = item.code
          }
        })
      },
      arrCityCodeList(item_id) {
        if (item_id !== '') {
          this.resRegion.map((item, index) => {
            if (item.id === item_id) {
              this.strCityCodeList = item.cityCodeList.join()
            }
          })
        }
      },
      getParams() {
        this.params = {
          adminLocationControl: this.strCityCodeList.split(','),
          adminLocationLevel: this.locationLevel,
        }
        if (this.strCityCodeList === '') {
          const adminLocations =
            this.dataUser && this.dataUser.adminLocations ? this.dataUser.adminLocations : []
          this.params.adminLocationControl = adminLocations
        }
        if (this.mcc.length > 0) {
          this.params.mccList = this.mcc
        }
        if (this.searchServiceType.length > 0) {
          this.params.serviceTypeList = this.searchServiceType
        }

        return this.params
      },
      async clickSearch() {
        this.loadingScreen = true
        this.dataShow = []
        this.locations = []
        this.getArrNoDegrees()
        this.getParams()
        const dataShow = await MerchantService.getNoMerchants(this.params)
        dataShow.map(item => {
          const tmp = {
            locationCode: item.adminLocationCode,
            locationName: item.adminLocationName,
            noMerchants: item.count,
            mapColor: this.arrNoDegrees.find(s => s.min <= item.count && s.max >= item.count).color,
            mapIndex: this.arrNoDegrees.findIndex(s => s.min <= item.count && s.max >= item.count),
          }
          this.dataShow.push(tmp)
        })
        const locations = await this.dataMapping()
        this.locations = locations.map(loc => {
          const matchedAggrData = this.dataShow.find(elem => elem.locationCode === loc.code)
          if (!matchedAggrData) {
            const options = {
              strokeColor: '#000000',
              strokeWeight: 0.15,
              fillColor: '#FFFFFF',
              fillOpacity: 1,
            }
            return { code: loc.code, name: loc.name, level: loc.level, polygon: loc.paths, options }
          }
          const options = {
            strokeColor: '#000000',
            strokeWeight: 0.15,
            fillColor: matchedAggrData.mapColor,
            fillOpacity: 1,
          }
          return { code: loc.code, name: loc.name, level: loc.level, polygon: loc.paths, options }
        })
        this.loadingScreen = false
      },
      setMapNo(num) {
        const noMerchantsPerDegree = 1000
        const noDegrees = 11
        if (num <= 10) return 0
        return Math.min(noDegrees - 1, Math.ceil(num / noMerchantsPerDegree))
      },
      removeStrCityCodeList() {
        this.region = ''
        this.province = ''
        this.district = ''
        this.strCityCodeList = ''
        this.mcc = []
        this.searchServiceType = []
        this.optionProvince = []
        this.optionDistrict = []
        this.clickSearch()
      },
      dragMap() {},
      clickMap() {},
      changeMapCenter(event) {},
      showLocationDetails(event, loc) {
        this.infoWindow.position = event.latLng
        this.infoWindow.options.content = `<div>
          <div> Mã: ${loc.code} </div>
          <div> Tên: ${loc.name} </div>
        </div>`
        this.infoWindow.isOpened = true
      },
      async dataMapping() {
        const mapLocations = await LocationService.mockingLocations(
          this.params.adminLocationControl,
          this.locationLevel
        )
        const result = mapLocations.filter(loc => {
          return this.params.adminLocationControl.some(controlLocCode =>
            loc.code.startsWith(controlLocCode)
          )
        })
        return result
      },
    },
  }
</script>
<style scoped>
  .box-search .form-group.form-group-ext {
    width: 410px;
  }

  .box-search .border-radis-3 {
    border-radius: 5px;
  }

  /* Table Container Styling */
  .table-container {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid #e0e0e0;
  }

  .table-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    font-weight: 600;
  }

  /* Loading State */
  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    min-height: 400px;
  }

  .loading-state p {
    color: #667eea;
    font-weight: 500;
    font-size: 16px;
  }

  /* Table Wrapper */
  .table-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  /* Merchant Table Styling */
  .merchant-table {
    margin-bottom: 0 !important;
  }

  .merchant-table thead th {
    background-color: #f8f9fa;
    color: #495057;
    font-weight: 600;
    border-bottom: 2px solid #667eea;
    padding: 12px;
  }

  .merchant-table tbody tr:hover {
    background-color: #f0f4ff !important;
    transform: scale(1.01);
    transition: all 0.2s ease;
  }

  .merchant-table tbody td {
    padding: 12px;
    vertical-align: middle;
  }

  /* Badge Styling */
  .badge-primary {
    background-color: #667eea;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 600;
  }

  .badge-info {
    background-color: #17a2b8;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 600;
  }

  /* Stats Row */
  .stats-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .stat-label {
    font-weight: 600;
    color: #495057;
  }

  .color-level-detail {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding-top: 8px;
    border-top: 1px solid #e9ecef;
  }

  .level-badge {
    color: #6c757d;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
  }

  /* Legend Mini */
  .legend-mini {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .color-sample {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    cursor: help;
  }

  /* Pagination Styling */
  .pagination {
    margin-bottom: 0;
  }

  .page-link {
    color: #667eea;
    border-color: #dee2e6;
  }

  .page-link:hover {
    color: #764ba2;
    background-color: #f0f4ff;
    border-color: #667eea;
  }

  .page-item.active .page-link {
    background-color: #667eea;
    border-color: #667eea;
  }
</style>
